import { CoreIcon } from '../core-icon';
import listSVG from '../../assets/icons/list.svg';
import type { IconProps } from '../core-icon';

export const ListIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={listSVG} {...props} />;
};
